
<div class="tracking-host" [class.tracking-host--floating]="display === 'floating'"
  [class.tracking-host--open]="isOpen">
  @if (display === 'floating') {
  <button type="button" class="tracking-tab" (click)="toggle()"
    [attr.aria-label]="('app.trackingRequest.title' | translate)" [attr.aria-expanded]="isOpen">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m22 2-7 20-4-9-9-4L22 2ZM11 13 22 2" />
    </svg>
  </button>
  }

  <section class="tracking-card" [attr.aria-label]="('app.trackingRequest.title' | translate)">
    <div class="tracking-top">
      <div class="tracking-heading">
        <h2>{{ 'app.trackingRequest.title' | translate }}</h2>
        <p>{{ 'app.trackingRequest.subtitle' | translate }}</p>
      </div>
      <div class="tracking-package" aria-hidden="true">
        <span class="tracking-orbit"></span>
        <svg viewBox="0 0 130 125" class="tracking-package-svg">
          <defs>
            <linearGradient id="trBoxFront" x1="0" y1="0" x2="1" y2="1">
              <stop stop-color="#ffe58a" />
              <stop offset=".55" stop-color="#ffb42b" />
              <stop offset="1" stop-color="#d87713" />
            </linearGradient>
            <linearGradient id="trBoxSide" x1="0" y1="0" x2="1" y2="1">
              <stop stop-color="#ffa91c" />
              <stop offset="1" stop-color="#ac4a09" />
            </linearGradient>
            <linearGradient id="trPin" x1="0" y1="0" x2="1" y2="1">
              <stop stop-color="#ffbe6a" />
              <stop offset=".25" stop-color="#ff5437" />
              <stop offset=".7" stop-color="#e21816" />
              <stop offset="1" stop-color="#9c090e" />
            </linearGradient>
            <filter id="trShadow">
              <feGaussianBlur stdDeviation="3" />
            </filter>
          </defs>
          <ellipse cx="66" cy="106" rx="51" ry="9" fill="#00285d" opacity=".4" filter="url(#trShadow)" />
          <path d="M20 58 64 38 109 58 65 80Z" fill="#ffdd79" stroke="#fff3b6" stroke-width="2" />
          <path d="M20 58 65 80 65 116 20 94Z" fill="url(#trBoxFront)" stroke="#d37b1c" stroke-width="1.5" />
          <path d="M65 80 109 58 109 94 65 116Z" fill="url(#trBoxSide)" stroke="#b96512" stroke-width="1.5" />
          <path d="M48 46 92 66 92 78 83 74 83 62 39 42Z" fill="#f7b978" opacity=".85" />
          <path d="M38 104v-10m-4 4 4-4 4 4m10 11V99m-4 4 4-4 4 4" fill="none" stroke="#753a12" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M66 5C48 5 37 18 37 34c0 23 29 46 29 46s29-23 29-46C95 18 84 5 66 5Z" fill="url(#trPin)"
            stroke="#ffb17e" stroke-width="2" />
          <ellipse cx="66" cy="34" rx="12" ry="12" fill="#5acfff" stroke="#a50000" stroke-width="5" />
          <path d="M44 20c7-12 25-15 37-5" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round"
            opacity=".7" />
        </svg>
      </div>
    </div>

    <div class="tracking-switch" role="group" [attr.aria-label]="('app.trackingRequest.systemLabel' | translate)">
      <span class="tracking-switch-glow" [class.tracking-switch-glow--carrier]="selectedSystem === 'carrier'"></span>
      <button type="button" class="tracking-switch-option" [class.active]="selectedSystem === 'globex'"
        [attr.aria-pressed]="selectedSystem === 'globex'" (click)="selectSystem('globex')">
        <img src="assets/images/globex-tracking.png" class="tracking-globex-logo" alt="" aria-hidden="true" />
        <span>GLOBEX</span>
      </button>
      <button type="button" class="tracking-switch-option" [class.active]="selectedSystem === 'carrier'"
        [attr.aria-pressed]="selectedSystem === 'carrier'" (click)="selectSystem('carrier')">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M2 5h12v12H2V5Zm12 5h4l4 4v3h-8v-7ZM6 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm10 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z" />
        </svg>
        <span>{{ 'app.trackingRequest.carrier' | translate }}</span>
      </button>
    </div>

    <form class="tracking-bottom" (ngSubmit)="trackShipment()">
      <label class="sr-only" for="tracking-request-number">{{ 'app.trackingRequest.number' | translate }}</label>
      <input id="tracking-request-number" name="trackingNumber" type="text" [(ngModel)]="trackingNumber"
        [placeholder]="('app.trackingRequest.number' | translate)" autocomplete="off" spellcheck="false" />
      <button class="tracking-submit" type="submit" [disabled]="!trackingNumber.trim() || isTracking" [attr.aria-busy]="isTracking">
        @if (isTracking) {
        <span class="tracking-submit-spinner" aria-hidden="true"></span>
        } @else {
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="10.8" cy="10.8" r="7" />
          <path d="m16 16 5.2 5.2" />
        </svg>
        }
        <span>{{ 'app.trackingRequest.track' | translate }}</span>
      </button>
    </form>
  </section>
</div>
